const STORAGE_KEY = 'fixe-sidebar-collapsed';

export function getSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setSidebarCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    /* storage indisponível */
  }
}

export const SIDEBAR_WIDTH_EXPANDED = 268;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
